import React from "react";
import useAdminListPartners from "../hooks/useAdminListPartners";
import useAPI from "../hooks/useAPI";
import StickyHeadTable from "./StickyHeadTable";
import { isMobile } from "react-device-detect";
import { useDispatch, useSelector } from "react-redux";
import { partnersActions } from "../state/partners";

export default function AdminListPartners(props) {
  const { handleDelete, onEdit, businessType } = useAdminListPartners(props);

  const dispatch = useDispatch();

  const { data: dataPartners, query: fetchData } = useAPI({
    type: "get",
    url: `partners`,
  });

  const items = useSelector((state) => state.partners.partners);

  const handleRefreshData = async () => {
    await fetchData();
  };

  React.useEffect(() => {
    if (dataPartners && dataPartners.data) {
      dispatch(partnersActions.fetchAll(dataPartners.data));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dataPartners]);

  // useMemo est utilisé ici pour mémoriser la définition des
  // colonnes affichées dans le tableau.
  // permet d'éviter de recréer l'objet des colonnes à chaque rendu du composant,
  const displayedColumns = React.useMemo(() => {
    const baseColumns = [
      { id: "id", label: "ID", minWidth: 50 },
      { id: "name", label: "Nom", minWidth: 150 },
      { id: "location", label: "Lieu", minWidth: 100 },
      { id: "website", label: "Site Web", minWidth: 100 },
      { id: "created", label: "Date", minWidth: 100 },
      { id: "action", label: "Actions", minWidth: isMobile ? 90 : 90 },
    ];
    return baseColumns;
  }, []);

  return (
    <div>
      <StickyHeadTable
        businessType={businessType}
        filters={["id", "name", "location", "website", "created"]}
        columns={
          isMobile
            ? displayedColumns.filter(
                (c) => c.id === "name" || c.id === "action"
              )
            : displayedColumns
        }
        data={items.map((p) => ({
          id: p.id.toString(),
          name: p.name,
          location: p.location || "",
          website: p.website || "",
          created: new Date(p.created).toLocaleDateString("fr-FR"),
          metadata: p.metadata,
        }))}
        onEdit={onEdit}
        onEdit2={() => {
          console.log("Edit 2 clicked");
        }}
        onRefreshData={handleRefreshData}
        onDelete={handleDelete}
      />
    </div>
  );
}
